import React, { useRef, useState } from "react";
import { FiSend } from "react-icons/fi";
import "./RaceFlyerEmailForm.scss";
import Header from "../clubDashboard/Header/Header";
import combinedServices from "../../shared/services/user-service";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { Link as LinkPage } from "react-router-dom";
import {
  HtmlEditor,
  Image,
  Inject,
  Link,
  QuickToolbar,
  RichTextEditorComponent,
  Toolbar,
  Table,
} from "@syncfusion/ej2-react-richtexteditor";
import userConstants from "../../shared/constants/user-constants";

const baseURL = userConstants.baseURL;

const EmailForm = () => {
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [editorData, setEditorData] = useState("");
  const event_id = useParams().id;

  const toolbarSettings = {
    items: [
      "Bold",
      "Italic",
      "Underline",
      "StrikeThrough",
      "FontName",
      "FontSize",
      "FontColor",
      "BackgroundColor",
      "LowerCase",
      "UpperCase",
      "|",
      "Formats",
      "Alignments",
      "OrderedList",
      "UnorderedList",
      "Outdent",
      "Indent",
      "|",
      "CreateLink",
      "Image",
      "|",
      "ClearFormat",
      "Print",
      "SourceCode",
      "FullScreen",
      "|",
      "Undo",
      "Redo",
    ],
  };

  const quickToolbarSettings = {
    image: [
      "Replace",
      "Align",
      "Caption",
      "Remove",
      "InsertLink",
      "OpenImageLink",
      "-",
      "EditImageLink",
      "RemoveImageLink",
      "Display",
      "AltText",
      "Dimension",
    ],
    link: ["Open", "Edit", "UnLink"],
  };

  const fontFamily = {
    items: [
      {
        text: "Segoe UI",
        value: "Segoe UI",
        class: "e-segoe-ui",
        command: "Font",
        subCommand: "FontName",
      },
      {
        text: "Roboto",
        value: "Roboto",
        command: "Font",
        subCommand: "FontName",
      },
      {
        text: "Montserrat",
        value: "Montserrat,sans-serif",
        command: "Font",
        subCommand: "FontName",
      },
      {
        text: "Arial",
        value: "Arial,Helvetica,sans-serif",
        command: "Font",
        subCommand: "FontName",
      },
      {
        text: "Courier New",
        value: "Courier New,Courier,monospace",
        command: "Font",
        subCommand: "FontName",
      },
      {
        text: "Georgia",
        value: "Georgia,serif",
        command: "Font",
        subCommand: "FontName",
      },
      {
        text: "Impact",
        value: "Impact,Charcoal,sans-serif",
        command: "Font",
        subCommand: "FontName",
      },
      {
        text: "Lucida Console",
        value: "Lucida Console,Monaco,monospace",
        command: "Font",
        subCommand: "FontName",
      },
      {
        text: "Tahoma",
        value: "Tahoma,Geneva,sans-serif",
        command: "Font",
        subCommand: "FontName",
      },
      {
        text: "Times New Roman",
        value: "Times New Roman,Times,serif",
        command: "Font",
        subCommand: "FontName",
      },
      {
        text: "Verdana",
        value: "Verdana,Geneva,sans-serif",
        command: "Font",
        subCommand: "FontName",
      },
    ],
  };
  const insertImageSettings = {
    saveUrl:
      "https://services.syncfusion.com/js/production/api/FileUploader/Save",
    removeUrl:
      "https://services.syncfusion.com/js/production/api/FileUploader/Remove",
    height: 165,
    width: 165,
  };

  const saveContent = (e) => {
    // Create a temporary DOM element to work with the HTML content
    const tempElement = document.createElement("div");
    tempElement.innerHTML = e.value;

    // Loop through all the images in the content
    const images = tempElement.querySelectorAll("img");
    images.forEach((img) => {
      // Check if the image has a blob URL
      if (img.src.startsWith("blob:")) {
        // Replace the blob URL with the actual image URL
        img.src = imageUrl; // Replace with your actual image URL
      }
    });

    // Convert the modified HTML content back to a string and update the editor data
    const modifiedContent = tempElement.innerHTML;
    setEditorData(modifiedContent);
  };

  const imageUploadHandler = async (args) => {
    try {
      const files = args.file.rawFile;
      const formData = new FormData();
      formData.append("image", files);

      const response = await combinedServices.uploadImage(formData);

      const imageUrl = response.data.location;
      // Create a new image element
      const imageElement = document.createElement("img");
      imageElement.setAttribute("src", imageUrl);
      imageElement.setAttribute("alt", "Uploaded Image");
      // imageElement.setAttribute("width", "165px"); // Adjust as needed
      // imageElement.setAttribute("height", "165px"); // Adjust as needed
      setImageUrl(imageUrl);
      // Create a new paragraph element
      const paragraph = document.createElement("p");
      paragraph.appendChild(imageElement);
      editorData.append(paragraph);
    } catch (error) {
      console.error(error);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!subject.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Missing Subject",
        text: "Please enter an email subject.",
      });
      return;
    }

    if (!editorData.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Missing Content",
        text: "Please enter email content.",
      });
      return;
    }

    setIsSubmitting(true);

    try {
      await combinedServices.sendRaceFlyerEmail({
        subject,
        body: editorData,
        event_id,
      });

      Swal.fire({
        icon: "success",
        title: "Emails Sent!",
        text: "The race flyer email was sent successfully.",
        timer: 3000,
        showConfirmButton: false,
      });

      setSubject("");
      setBody("");
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Failed to Send",
        text: "Failed to send emails. Please try again.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div style={{ backgroundColor: "#ebedf5", minHeight: "100vh" }}>
      <Header />

      <div className="email-form-container dbRight">
        <div className="container flexBox">
          <div style={{ color: "black" }}>
           
            <div className="bradcrumb">
              <LinkPage to="/event-management" style={{ color: "gray" }}>
                Home
              </LinkPage>
              <LinkPage to="" style={{ color: "black" }}>
                Compose Race Email
              </LinkPage>
            </div>
          </div>
        </div>
        <div className="email-form-card" style={{marginTop:"20px"}}>
          <h2>Compose Race Email</h2>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="subject">Email Subject</label>
              <input
                type="text"
                id="subject"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                placeholder="Enter email subject"
                disabled={isSubmitting}
              />
            </div>

            <div className="form-group">
              <label htmlFor="body">Email Body</label>
              <RichTextEditorComponent
                height={300}
                width={800}
                toolbarSettings={toolbarSettings}
                quickToolbarSettings={quickToolbarSettings}
                value={editorData}
                change={saveContent}
                imageUploadSuccess={imageUploadHandler}
                insertImageSettings={insertImageSettings}
              >
                <Inject
                  services={[
                    Toolbar,
                    Image,
                    Link,
                    HtmlEditor,
                    QuickToolbar,
                    Table,
                  ]}
                />
              </RichTextEditorComponent>
            </div>

            <div className="form-actions">
              <div></div>
              <button
                type="submit"
                className={`send-button ${isSubmitting ? "sending" : ""}`}
                disabled={isSubmitting}
              >
                <FiSend size={18} />
                {isSubmitting ? "Sending..." : "Send Emails"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EmailForm;
